import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from 'react-router-dom';

import './Services.css';
import System from '../components/services/System';
import Modal from '../components/Modal';
import OffGridContent from '../components/services/OffGridContent';
import OnGridContent from '../components/services/OnGridContent';
import EstudiosConexionContent from '../components/services/EstudiosConexionContent';
import MantenimientoFotovoltaicoContent from '../components/services/MantenimientoFotovoltaicoContent';
import RedesBajaTensionContent from '../components/services/RedesBajaTensionContent';
import EstudiosIluminacionContent from '../components/services/EstudiosIluminacionContent';
import AcompanamientoTecnicoContent from '../components/services/AcompanamientoTecnicoContent';
import PlanosElectricosContent from '../components/services/PlanosElectricosContent';
import RetieContent from '../components/services/Retie';
import TramitesOperadorContent from './services/Tramites-Operador';
import MantenimientoTanqueContent from './services/MantenimientoTanque';
import InstalacionHeatPipeContent from './services/InstalacionHeatPipe';
import RespaldoUPSContent from './services/RespaldoUPS';
import CitofoniaContent from './services/Citofonia';
import AntirroboContent from './services/Antirrobo';

// Importa las imágenes para el panel derecho
import HeapPipeNBImage from '../assets/termotanque.avif';
import PanelNBImage from '../assets/Panel.avif';
import InstalacionNBImage from '../assets/instalacionNB2.png';
import RetieNBImage from '../assets/RetieNB.avif';
import UpsNB from '../assets/UpsNB.avif';
import CitfonoNM from '../assets/CitofonoNB.avif';

const services = [
  {
    title: 'Sistemas Fotovoltaicos',
    category: 'ENERGÍA',
    description: 'Soluciones solares adaptadas a tu hogar o empresa.',
    subServices: [
      'Mantenimiento de sistemas fotovoltaicos',
      'Estudios de conexión',
      'Off grid',
      'On grid',
    ],
    image: '../assets/fondo.avif',
    largeImageText: 'Panel Solar',
    rightPanelImage: PanelNBImage,
    rightPanelDescription:
      'Descubre cómo nuestros sistemas fotovoltaicos pueden transformar tu consumo energético y ofrecerte independencia.',
  },
  {
    title: 'Instalaciones Eléctricas',
    category: 'ELECTRICIDAD',
    description: 'Diseño e implementación segura y eficiente.',
    subServices: [
      'Redes de baja tensión',
      'Estudios de iluminación',
      'Acompañamiento técnico y revisiones eléctricas',
      'Planos Eléctricos y diagramas unifilares',
    ],
    image: '../assets/instalacion.avif',
    largeImageText: 'Instalación Eléctrica',
    rightPanelImage: InstalacionNBImage,
    rightPanelDescription:
      'Ofrecemos soluciones eléctricas seguras y eficientes para tu hogar o negocio, desde el diseño hasta la implementación.',
  },
  {
    title: 'Certificaciones RETIE',
    category: 'LEGALIZACIÓN',
    description: 'Tramitamos y gestionamos certificados RETIE.',
    subServices: [
      'Trámites de certificaciones RETIE',
      'Trámites ante el operador de red.',
    ],
    image: '../assets/retieC.avif',
    largeImageText: 'Certificación RETIE',
    rightPanelImage: RetieNBImage,
    rightPanelDescription:
      'Gestionamos tus certificaciones RETIE para asegurar que tus instalaciones cumplan con todas las normativas vigentes.',
  },
  {
    title: 'Sistemas de Calentamiento Solar (Heat Pipe)',
    category: 'AGUA CALIENTE',
    description: 'Instalación y suministro eficiente y ecológico.',
    subServices: [
      'Mantenimiento de sistemas de calentamiento solar',
      'Instalación y suministro de sistemas de calentamiento solar',
    ],
    image: '../assets/heapPipe.avif',
    largeImageText: 'Calentamiento Solar',
    rightPanelImage: HeapPipeNBImage,
    rightPanelDescription:
      'Disfruta de agua caliente de forma eficiente y ecológica con nuestros sistemas de calentamiento solar Heat Pipe. Reduce tu consumo de energía y contribuye al medio ambiente.',
  },
  {
    title: 'Sistemas de Respaldo UPS',
    category: 'ENERGÍA SEGURA',
    description: 'Protege tus equipos con sistemas de respaldo.',
    subServices: ['Sistemas de Respaldo UPS'],
    image: '../assets/ups.avif',
    largeImageText: 'Sistema UPS',
    rightPanelImage: UpsNB,
    rightPanelDescription:
      'Garantiza la continuidad de tus operaciones y protege tus equipos sensibles con nuestros sistemas de respaldo UPS de alta fiabilidad.',
  },
  {
    title: 'Portería Inteligente y Videoporteros',
    category: 'SEGURIDAD',
    description: 'Soluciones modernas para el acceso seguro.',
    subServices: ['Citofonía Inteligente', 'Pines Antirrobo'],
    image: '../assets/videoportero.avif',
    largeImageText: 'Videoportero',
    rightPanelImage: CitfonoNM,
    rightPanelDescription:
      'Moderniza la seguridad de tu propiedad con soluciones inteligentes de portería y videoporteros, ofreciendo control y tranquilidad.',
  },
];

const Services = () => {


  // 👉 AÑADIDO PARA ACTIVAR SCROLL SOLO AQUÍ
    useEffect(() => {
      document.body.classList.add("servicios");
      document.documentElement.classList.add("servicios");
  
      return () => {
        document.body.classList.remove("servicios");
        document.documentElement.classList.remove("servicios");
      };
    }, []);
    // 👉 FIN CAMBIO

  const [showSubServiceBanner, setShowSubServiceBanner] = useState(false);
  const [currentSubServices, setCurrentSubServices] = useState([]);
  const [currentServiceTitle, setCurrentServiceTitle] = useState('');
  const [selectedServiceIndex, setSelectedServiceIndex] = useState(0);

  const [modalAbiertoDesdeRuta, setModalAbiertoDesdeRuta] = useState(false);

  const { serviceIndex: index } = useParams();
  const [isPageReady, setIsPageReady] = useState(false);


  useEffect(() => {
    if (index && !isNaN(index) && parseInt(index) < services.length) {
      setSelectedServiceIndex(parseInt(index));
    }
  }, [index]);

  const handlePrev = () => {
    setSelectedServiceIndex((prevIndex) =>
      prevIndex === 0 ? services.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setSelectedServiceIndex((prevIndex) =>
      prevIndex === services.length - 1 ? 0 : prevIndex + 1
    );
  };
  const { subservice } = useParams(); // viene de /servicios/subservicio/:subservice


  const carouselRef = useRef(null);
  const initialSubservice = subservice?.toLowerCase();

  const [showSystemModal, setShowSystemModal] = useState(initialSubservice === 'sistema');
const [showOffGridModal, setShowOffGridModal] = useState(initialSubservice === 'off-grid');
const [showOnGridModal, setShowOnGridModal] = useState(initialSubservice === 'on-grid');
const [showEstudiosConexionModal, setShowEstudiosConexionModal] = useState(initialSubservice === 'conexion');
const [showMantenimientoFotovoltaicoModal, setShowMantenimientoFotovoltaicoModal] = useState(initialSubservice === 'mantenimiento-fotovoltaico');
const [showRedesBajaTensionModal, setShowRedesBajaTensionModal] = useState(initialSubservice === 'redes-baja');
const [showEstudiosIluminacionModal, setShowEstudiosIluminacionModal] = useState(initialSubservice === 'iluminacion');
const [showAcompanamientoTecnicoModal, setShowAcompanamientoTecnicoModal] = useState(initialSubservice === 'acompanamiento');
const [showPlanosElectricosModal, setShowPlanosElectricosModal] = useState(initialSubservice === 'planos-electricos');
const [showRetieModal, setShowRetieModal] = useState(initialSubservice === 'retie');
const [showTramitesOperador, setShowTramitesOperador] = useState(initialSubservice === 'tramites-operador');
const [showMantenimientoTanque, setShowMantenimientoTanque] = useState(initialSubservice === 'mantenimiento-tanque');
const [showInstalacionHeatPipe, setShowInstalacionHeatPipe] = useState(initialSubservice === 'instalacion-heatpipe');
const [showRespaldoUPS, setShowRespaldoUPS] = useState(initialSubservice === 'respaldo-ups');
const [showCitofonia, setShowCitofonia] = useState(initialSubservice === 'citofonia');
const [showAntirrobo, setShowAntirrobo] = useState(initialSubservice === 'antirrobo');


  useEffect(() => {
    if (
      showAntirrobo ||
      showCitofonia ||
      showRespaldoUPS ||
      showInstalacionHeatPipe ||
      showMantenimientoTanque ||
      showTramitesOperador ||
      showSubServiceBanner ||
      showSystemModal ||
      showOffGridModal ||
      showOnGridModal ||
      showEstudiosConexionModal ||
      showMantenimientoFotovoltaicoModal ||
      showRedesBajaTensionModal ||
      showEstudiosIluminacionModal ||
      showAcompanamientoTecnicoModal ||
      showPlanosElectricosModal ||
      showRetieModal
    ) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return () => {
      // Limpieza al desmontar el componente
      document.body.classList.remove('no-scroll');
    };
  }, [
    showAntirrobo,
    showCitofonia,
    showRespaldoUPS,
    showInstalacionHeatPipe,
    showMantenimientoTanque,
    showSubServiceBanner,
    showSystemModal,
    showOffGridModal,
    showOnGridModal,
    showEstudiosConexionModal,
    showMantenimientoFotovoltaicoModal,
    showRedesBajaTensionModal,
    showEstudiosIluminacionModal,
    showAcompanamientoTecnicoModal,
    showPlanosElectricosModal,
    showRetieModal,
    showTramitesOperador,
  ]);

  // Efecto para centrar la tarjeta seleccionada al cargar o cambiar la selección
  useEffect(() => {
    if (carouselRef.current) {
      const selectedCardElement =
        carouselRef.current.children[selectedServiceIndex];
      if (selectedCardElement) {
        selectedCardElement.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest',
        });
      }
    }
  }, [selectedServiceIndex]); // Dependencia del índice seleccionado

  


  const navigate = useNavigate();

  const openSystemModal = useCallback(() => {
  setShowSystemModal(true);
  if (window.location.pathname !== '/servicios/sistema') {
    navigate('/servicios/sistema');
  }
}, [navigate]);

const openOffGridModal = useCallback(() => {
  setShowOffGridModal(true);
  if (window.location.pathname !== '/servicios/off-grid') {
    navigate('/servicios/off-grid');
  }
}, [navigate]);

const openOnGridModal = useCallback(() => {
  setShowOnGridModal(true);
  if (window.location.pathname !== '/servicios/on-grid') {
    navigate('/servicios/on-grid');
  }
}, [navigate]);

const openEstudiosConexionModal = useCallback(() => {
  setShowEstudiosConexionModal(true);
  if (window.location.pathname !== '/servicios/conexion') {
    navigate('/servicios/conexion');
  }
}, [navigate]);

const openMantenimientoFotovoltaicoModal = useCallback(() => {
  setShowMantenimientoFotovoltaicoModal(true);
  if (window.location.pathname !== '/servicios/mantenimiento-fotovoltaico') {
    navigate('/servicios/mantenimiento-fotovoltaico');
  }
}, [navigate]);

const openRedesBajaTensionModal = useCallback(() => {
  setShowRedesBajaTensionModal(true);
  if (window.location.pathname !== '/servicios/redes-baja') {
    navigate('/servicios/redes-baja');
  }
}, [navigate]);

const openEstudiosIluminacionModal = useCallback(() => {
  setShowEstudiosIluminacionModal(true);
  if (window.location.pathname !== '/servicios/iluminacion') {
    navigate('/servicios/iluminacion');
  }
}, [navigate]);

const openAcompanamientoTecnicoModal = useCallback(() => {
  setShowAcompanamientoTecnicoModal(true);
  if (window.location.pathname !== '/servicios/acompanamiento') {
    navigate('/servicios/acompanamiento');
  }
}, [navigate]);

const openPlanosElectricosModal = useCallback(() => {
  setShowPlanosElectricosModal(true);
  if (window.location.pathname !== '/servicios/planos-electricos') {
    navigate('/servicios/planos-electricos');
  }
}, [navigate]);

const openRetieModal = useCallback(() => {
  setShowRetieModal(true);
  if (window.location.pathname !== '/servicios/retie') {
    navigate('/servicios/retie');
  }
}, [navigate]);

const openTramitesOperadorModal = useCallback(() => {
  setShowTramitesOperador(true);
  if (window.location.pathname !== '/servicios/tramites-operador') {
    navigate('/servicios/tramites-operador');
  }
}, [navigate]);

const openMantenimientoTanqueModal = useCallback(() => {
  setShowMantenimientoTanque(true);
  if (window.location.pathname !== '/servicios/mantenimiento-tanque') {
    navigate('/servicios/mantenimiento-tanque');
  }
}, [navigate]);

const openInstalacionHeatPipe = useCallback(() => {
  setShowInstalacionHeatPipe(true);
  if (window.location.pathname !== '/servicios/instalacion-heatpipe') {
    navigate('/servicios/instalacion-heatpipe');
  }
}, [navigate]);

const openRespaldoUPS = useCallback(() => {
  setShowRespaldoUPS(true);
  if (window.location.pathname !== '/servicios/respaldo-ups') {
    navigate('/servicios/respaldo-ups');
  }
}, [navigate]);

const openCitofonia = useCallback(() => {
  setShowCitofonia(true);
  if (window.location.pathname !== '/servicios/citofonia') {
    navigate('/servicios/citofonia');
  }
}, [navigate]);

const openAntirrobo = useCallback(() => {
  setShowAntirrobo(true);
  if (window.location.pathname !== '/servicios/antirrobo') {
    navigate('/servicios/antirrobo');
  }
}, [navigate]);
useEffect(() => {
  setIsPageReady(true);
}, []);


  useEffect(() => {
  if (!subservice || !isPageReady) return;

  setModalAbiertoDesdeRuta(true);

  switch (subservice.toLowerCase()) {
    case 'sistema':
      openSystemModal();
      break;
    case 'off-grid':
      openOffGridModal();
      break;
    case 'on-grid':
      openOnGridModal();
      break;
    case 'conexion':
      openEstudiosConexionModal();
      break;
    case 'mantenimiento-fotovoltaico':
      openMantenimientoFotovoltaicoModal();
      break;
    case 'redes-baja':
      openRedesBajaTensionModal();
      break;
    case 'iluminacion':
      openEstudiosIluminacionModal();
      break;
    case 'acompanamiento':
      openAcompanamientoTecnicoModal();
      break;
    case 'planos-electricos':
      openPlanosElectricosModal();
      break;
    case 'retie':
      openRetieModal();
      break;
    case 'tramites-operador':
      openTramitesOperadorModal();
      break;
    case 'mantenimiento-tanque':
      openMantenimientoTanqueModal();
      break;
    case 'instalacion-heatpipe':
      openInstalacionHeatPipe();
      break;
    case 'respaldo-ups':
      openRespaldoUPS();
      break;
    case 'citofonia':
      openCitofonia();
      break;
    case 'antirrobo':
      openAntirrobo();
      break;
    default:
      break;
  }
}, [subservice, isPageReady, openSystemModal,
    openOffGridModal,
    openOnGridModal,
    openEstudiosConexionModal,
    openMantenimientoFotovoltaicoModal,
    openRedesBajaTensionModal,
    openEstudiosIluminacionModal,
    openAcompanamientoTecnicoModal,
    openPlanosElectricosModal,
    openRetieModal,
    openTramitesOperadorModal,
    openMantenimientoTanqueModal,
    openInstalacionHeatPipe,
    openRespaldoUPS,
    openCitofonia,
    openAntirrobo]);


  const openSubServiceBanner = (service) => {
    setCurrentSubServices(service.subServices);
    setCurrentServiceTitle(service.title);
    setShowSubServiceBanner(true);
    window.history.pushState({ modal: 'subServiceBanner' }, '', '#subservices');
  };

  const closeOnGridModal = () => {
    setShowOnGridModal(false);
    if (!modalAbiertoDesdeRuta) navigate('/servicios');
  };

  const closeSubServiceBanner = () => {
    setShowSubServiceBanner(false);
    setCurrentSubServices([]);
    setCurrentServiceTitle('');
  };

  const closeSystemModal = () => {
    setShowSystemModal(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/0');
  };

  const closeOffGridModal = () => {
    setShowOffGridModal(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/0');
  };

  const closeEstudiosConexionModal = () => {
    setShowEstudiosConexionModal(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/0');
  };

  const closeMantenimientoFotovoltaicoModal = () => {
    setShowMantenimientoFotovoltaicoModal(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/0');
  };

  const closeRedesBajaTensionModal = () => {
    setShowRedesBajaTensionModal(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/1');
  };

  const closeEstudiosIluminacionModal = () => {
    setShowEstudiosIluminacionModal(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/1');
  };

  const closeAcompanamientoTecnicoModal = () => {
    setShowAcompanamientoTecnicoModal(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/1');
  };

  const closePlanosElectricosModal = () => {
    setShowPlanosElectricosModal(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/1');
  };

  const closeRetieModal = () => {
    setShowRetieModal(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/2');
  };

  const closeTramiesOperadorModal = () => {
    setShowTramitesOperador(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/2');
  };

  const closeMantenimientoTanqueModal = () => {
    setShowMantenimientoTanque(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/3');
  };

  const closeInstalacionHeatPipe = () => {
    setShowInstalacionHeatPipe(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/3');
  };

  const closeRespaldoUPS = () => {
    setShowRespaldoUPS(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/4');
  };

  const closeCitofonia = () => {
    setShowCitofonia(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/5');
  };

  const closeAntirrobo = () => {
    setShowAntirrobo(false);
    setModalAbiertoDesdeRuta(false);
    navigate('/servicios/5');
  };

  const handleSubServiceClick = (subService) => {
    if (subService === 'Off grid') {
      openOffGridModal();
    } else if (subService === 'On grid') {
      openOnGridModal();
    } else if (subService === 'Estudios de conexión') {
      openEstudiosConexionModal();
    } else if (subService === 'Mantenimiento de sistemas fotovoltaicos') {
      openMantenimientoFotovoltaicoModal();
    } else if (subService === 'Redes de baja tensión') {
      openRedesBajaTensionModal();
    } else if (subService === 'Estudios de iluminación') {
      openEstudiosIluminacionModal();
    } else if (
      subService === 'Acompañamiento técnico y revisiones eléctricas'
    ) {
      openAcompanamientoTecnicoModal();
    } else if (subService === 'Planos Eléctricos y diagramas unifilares') {
      openPlanosElectricosModal();
    } else if (subService === 'Trámites de certificaciones RETIE') {
      openRetieModal();
    } else if (subService === 'Trámites ante el operador de red.') {
      openTramitesOperadorModal();
    } else if (
      subService === 'Mantenimiento de sistemas de calentamiento solar'
    ) {
      openMantenimientoTanqueModal();
    } else if (
      subService ===
      'Instalación y suministro de sistemas de calentamiento solar'
    ) {
      openInstalacionHeatPipe();
    } else if (subService === 'Sistemas de Respaldo UPS') {
      openRespaldoUPS();
    } else if (subService === 'Citofonía Inteligente') {
      openCitofonia();
    } else if (subService === 'Pines Antirrobo') {
      openAntirrobo();
    }
  };

  const handleServiceSelect = (index) => {
  // Si el usuario hace clic en la tarjeta que ya está seleccionada
  if (selectedServiceIndex === index) {
    const currentTitle = services[index].title;

    // Abrir el modal correspondiente según el servicio
    switch (currentTitle) {
      case 'Sistemas Fotovoltaicos':
        openSubServiceBanner(services[index]);
        break;
      case 'Instalaciones Eléctricas':
        openSubServiceBanner(services[index]);
        break;
      case 'Certificaciones RETIE':
        openSubServiceBanner(services[index]);
        break;
      case 'Sistemas de Calentamiento Solar (Heat Pipe)':
        openSubServiceBanner(services[index]);
        break;
      case 'Sistemas de Respaldo UPS':
        openSubServiceBanner(services[index]);
        break;
      case 'Portería Inteligente y Videoporteros':
        openSubServiceBanner(services[index]);
        break;
      default:
        break;
    }
  } else {
    // Si el clic fue en otra tarjeta, solo seleccionarla
    setSelectedServiceIndex(index);
    navigate(`/servicios/${index}`);
  }
};

  const currentService = services[selectedServiceIndex];

  const generateMetaDescription = () => {
    switch (currentService.title) {
      case 'Sistemas Fotovoltaicos':
        return 'Instalamos sistemas fotovoltaicos en Pamplona o cualquier ciudad principalmente en Norte de Santander. Energía solar para hogares y empresas, incluyendo on grid, off grid y mantenimiento.';
      case 'Instalaciones Eléctricas':
        return 'Diseñamos e instalamos redes eléctricas seguras en Pamplona. Especialistas en baja tensión, iluminación y acompañamiento técnico.';
      case 'Certificaciones RETIE':
        return 'Gestionamos certificados RETIE y trámites ante el operador de red en Norte de Santander. Cumple con la normativa vigente con nosotros.';
      case 'Sistemas de Calentamiento Solar (Heat Pipe)':
        return 'Instalamos sistemas de calentamiento solar Heat Pipe en Pamplona. Ahorra energía con soluciones sostenibles.';
      case 'Sistemas de Respaldo UPS':
        return 'Protege tus equipos eléctricos con respaldo UPS. Instalación profesional en Pamplona y Norte de Santander.';
      case 'Portería Inteligente y Videoporteros':
        return 'Instalamos videoporteros y citofonía inteligente para tu seguridad en Pamplona. Control moderno de acceso.';
      default:
        return 'Conoce nuestros servicios de energía y electricidad en Pamplona, Norte de Santander. Ipsum Ingeniería: calidad e innovación.';
    }
  };

  useEffect(() => {
    const updateLayout = () => {
      const isVertical = window.innerHeight > window.innerWidth;
      document.body.classList.toggle('vertical-screen', isVertical);
    };

    updateLayout(); // Ejecuta al cargar
    window.addEventListener('resize', updateLayout); // Escucha cambios

    return () => window.removeEventListener('resize', updateLayout); // Limpieza
  }, []);

  return (
    <section id="services" className="services-section">
      <Helmet>
        <title>{currentService.title} | Servicios | Ipsum</title>
        <meta name="description" content={generateMetaDescription()} />
        <meta
          name="keywords"
          content={`paneles solares, sistemas fotovoltaicos, RETIE, electricidad, energía solar, Ipsum ${currentService.title}, Cúcuta, Ocaña,Bucaramanga, Toledo, Pamplona, Norte de Santander`}
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content={`${currentService.title} | Ipsum Ingeniería`}
        />
        <meta property="og:description" content={generateMetaDescription()} />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://www.ipsumiei.com.co/servicios`}
        />
        <meta
          property="og:image"
          content={`https://www.ipsumiei.com.co/logo-og.png`}
        />
      </Helmet>
      <div className="services-header">
        {/* Static Header for Desktop */}
        <div className="desktop-header-content">
          <h2>{currentService.title}</h2>
          <p>{currentService.description}</p>
        </div>

        {/* Dynamic Header for Mobile */}
        <div className="mobile-header-content">
          <h2>{currentService.title}</h2>
          <p>{currentService.description}</p>
        </div>
      </div>

      <div className="services-selection-container">
        {/* Panel Derecho: Contenido detallado del servicio seleccionado (Mobile: at top, Desktop: at right) */}
        <div className="service-right-panel">
          {currentService.rightPanelImage && (
            <img
              src={currentService.rightPanelImage}
              alt={currentService.title}
              className="right-panel-image"
            />
          )}
          {/* The title and description within right-panel remain hidden per your previous instruction */}
          <h3 className="right-panel-title">{currentService.title}</h3>
          <p className="right-panel-description">
            {currentService.rightPanelDescription || currentService.description}
          </p>
        </div>

        {/* Panel Izquierdo: Carrusel de tarjetas y botones (Mobile: at bottom, Desktop: at left) */}
        <div className="service-left-panel">
          {/* Carrusel Horizontal de tarjetas de selección de servicio */}
          <div
            className="service-selection-cards carousel-container"
            ref={carouselRef}
            onTouchStart={(e) => e.stopPropagation()}
            onTouchMove={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
          >
            {services.map((service, index) => {
              const distance = Math.abs(index - selectedServiceIndex);
              const scale =
                0.99 - (distance === 0.5 ? 0.1 : distance > 1 ? 0.01 : 0);
              const opacity =
                1 - (distance === 1 ? 0.01 : distance > 1 ? 0.01 : 0);

              return (
                <div
                  className={`service-card-thumbnail ${selectedServiceIndex === index ? 'selected-card-thumbnail' : ''} ${service.title === 'Sistemas Fotovoltaicos' ? 'service-card-fotovoltaicos' : ''} ${service.title === 'Instalaciones Eléctricas' ? 'service-card-instalaciones-electricas' : ''} ${service.title === 'Certificaciones RETIE' ? 'service-card-certificaciones-retie' : ''} ${service.title === 'Sistemas de Calentamiento Solar (Heat Pipe)' ? 'service-card-calentamiento-solar' : ''} ${service.title === 'Sistemas de Respaldo UPS' ? 'service-card-ups' : ''} ${service.title === 'Portería Inteligente y Videoporteros' ? 'service-card-videoporteros' : ''}`}
                  key={index}
                  onClick={() => handleServiceSelect(index)}
                  style={{
                    transform: `
                    scale(${scale})
                    rotateY(${index < selectedServiceIndex ? 10 : index > selectedServiceIndex ? 20 : 0}deg)
                    translateZ(${index === selectedServiceIndex ? 0 : 20}px) `,
                    opacity: opacity,
                    zIndex: services.length - distance,
                    transition: 'transform 0.5s ease, opacity 0.5s ease',
                  }}
                >
                  <h4 className="thumbnail-title">{service.title}</h4>
                </div>
              );
            })}
          </div>

          {/* Sección de botones debajo de la tarjeta seleccionada */}

          <div className="service-action-buttons">
            {/* Indicadores y flechas */}
            <div className="carousel-indicators">
              <div className="indicator-arrow" onClick={handlePrev}>
                {' '}
                ‹
              </div>
              {services.map((_, index) => (
                <div
                  key={index}
                  className={`carousel-dot ${selectedServiceIndex === index ? 'active' : ''}`}
                  onClick={() => handleServiceSelect(index)}
                />
              ))}
              <div className="indicator-arrow" onClick={handleNext}>
                ›
              </div>
            </div>
            {currentService.subServices.length > 0 && (
              <button
                className="service-button"
                onClick={() => openSubServiceBanner(currentService)}
              >
                Ver Servicios
              </button>
            )}
            {currentService.title === 'Sistemas Fotovoltaicos' && (
              <button
                className="service-button-extra"
                onClick={openSystemModal}
              >
                Ver Sistema
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Renderizado condicional del banner de sub-servicios (Modals) */}
      {showSubServiceBanner && (
        <div className="sub-services-banner-overlay">
          <div className="sub-services-banner">
            <button
              className="close-banner-button"
              onClick={closeSubServiceBanner}
            >
              &times;
            </button>
            <h3>Sub-servicios de {currentServiceTitle}</h3>
            {currentSubServices.length > 0 ? (
              <ul>
                {currentSubServices.map((sub, idx) => (
                  <li
                    onClick={() => handleSubServiceClick(sub)}
                    style={{ cursor: 'pointer' }}
                    key={idx}
                  >
                    <span
                      onClick={() => handleSubServiceClick(sub)}
                      style={{ cursor: 'pointer' }}
                    >
                      {sub}
                    </span>
                  </li>
                ))}
              </ul>
            ) : (
              <p>
                No hay sub-servicios específicos listados para este servicio.
              </p>
            )}
          </div>
        </div>
      )}

      {/* Modales para los contenidos específicos */}
      <Modal isOpen={showSystemModal} onClose={closeSystemModal}>
        <System />
      </Modal>

      <Modal isOpen={showOffGridModal} onClose={closeOffGridModal}>
        <OffGridContent />
      </Modal>

      <Modal isOpen={showOnGridModal} onClose={closeOnGridModal}>
        <OnGridContent />
      </Modal>

      <Modal
        isOpen={showEstudiosConexionModal}
        onClose={closeEstudiosConexionModal}
      >
        <EstudiosConexionContent />
      </Modal>

      <Modal
        isOpen={showMantenimientoFotovoltaicoModal}
        onClose={closeMantenimientoFotovoltaicoModal}
      >
        <MantenimientoFotovoltaicoContent />
      </Modal>

      <Modal
        isOpen={showRedesBajaTensionModal}
        onClose={closeRedesBajaTensionModal}
      >
        <RedesBajaTensionContent />
      </Modal>

      <Modal
        isOpen={showEstudiosIluminacionModal}
        onClose={closeEstudiosIluminacionModal}
      >
        <EstudiosIluminacionContent />
      </Modal>

      <Modal
        isOpen={showAcompanamientoTecnicoModal}
        onClose={closeAcompanamientoTecnicoModal}
      >
        <AcompanamientoTecnicoContent />
      </Modal>

      <Modal
        isOpen={showPlanosElectricosModal}
        onClose={closePlanosElectricosModal}
      >
        <PlanosElectricosContent />
      </Modal>

      <Modal isOpen={showRetieModal} onClose={closeRetieModal}>
        <RetieContent />
      </Modal>

      <Modal isOpen={showTramitesOperador} onClose={closeTramiesOperadorModal}>
        <TramitesOperadorContent />
      </Modal>

      <Modal
        isOpen={showMantenimientoTanque}
        onClose={closeMantenimientoTanqueModal}
      >
        <MantenimientoTanqueContent />
      </Modal>

      <Modal
        isOpen={showInstalacionHeatPipe}
        onClose={closeInstalacionHeatPipe}
      >
        <InstalacionHeatPipeContent />
      </Modal>

      <Modal isOpen={showRespaldoUPS} onClose={closeRespaldoUPS}>
        <RespaldoUPSContent />
      </Modal>

      <Modal isOpen={showCitofonia} onClose={closeCitofonia}>
        <CitofoniaContent />
      </Modal>

      <Modal isOpen={showAntirrobo} onClose={closeAntirrobo}>
        <AntirroboContent />
      </Modal>
    </section>
  );
};

export default Services;
